import { NgModule } from '@angular/core';

import { LinkComponent } from './link.component';

@NgModule({
  declarations: [
    LinkComponent,
  ],
  exports: [
    LinkComponent,
  ],
  providers: [],
})
export class LinkModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/LinkComponent/link.module.ts